import { Component } from '@angular/core';

@Component({
  selector: 'app-deliveryordersmobile',
  templateUrl: './deliveryordersmobile.component.html',
  styleUrl: './deliveryordersmobile.component.scss'
})
export class DeliveryordersmobileComponent {

}
